import React from 'react'
import RecentBallResults from '../components/RecentBallResults'
import './Score.scss'
import Powerbar from '../components/Powerbar'
import TeamScores from '../components/TeamScores'
import LiveBattingTable from '../components/LiveBattingTable'
import LiveBowlingTable from '../components/LiveBowlingTable'

export default function Score({ event, exchange, teams, scoreboard, powerbar, scoregrid, isHundred, teamFontSize }) {

    function getValueFromScoreboard(name) {
        let found;

        try {
            found = scoreboard[name]
        } catch (error) {
            console.log(error)
            console.log("Missing scoreboard field: ", name)
            return null;
        }

        if (! found) {
            return null;
        }

        return found;
    }

    const { team1winpercentage, team2winpercentage, drawpercentage } = powerbar || {};

    const scoreline = getValueFromScoreboard('scoreline')
    const teamOneName = getValueFromScoreboard('home')
    const teamTwoName = getValueFromScoreboard('away')

    let event_status = null

    if (exchange) {
        event_status = exchange.event_status
    }

    return (
        <div className="score">
            <div className="score-left">
                <TeamScores
                    teams={teams}
                    event={event}
                    scoreboard={scoreboard}
                    isHundred={isHundred}
                    teamFontSize={teamFontSize}
                />
                
                <div className="scoreline-and-bip">
                    <div className="scoreline">{ scoreline }</div>
                    { event_status === "BALL_IN_PROGRESS" ? <div className="bip">Ball In Play</div> : null}
                </div>

                <Powerbar
                    teamOneName={teamOneName}
                    teamTwoName={teamTwoName}
                    teamOneWinPercentage={team1winpercentage}
                    teamTwoWinPercentage={team2winpercentage}
                    drawPercentage={drawpercentage}
                    teamOneColor={teams[0].colour}
                    teamTwoColor={teams[1].colour}
                />

                <RecentBallResults scoregrid={scoregrid}/>

                <LiveBattingTable scoreboard={scoreboard} />
                <LiveBowlingTable scoreboard={scoreboard} isHundred={isHundred} />
            </div>
        </div>
    )
}
